import { BrowserStorageSessionService } from '@propertyfinder/pf-frontend-common/src/service/browser-storage-session/service';

import { CaptchaStorageStore } from 'common/module/captcha-storage/store';

const service = new CaptchaStorageStore(BrowserStorageSessionService());

export const CaptchaStorageService = (): typeof service => service;
